import { useTheme } from '../../../../theme';
import type { CSSObject } from '@emotion/react';

type Return = Record<'container', CSSObject>;

export const useToastNotificationStyles = (): Return => {
  const theme = useTheme();

  return {
    container: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(2),
      backgroundColor: theme.toast.notification.background,
      borderRadius: theme.shape.radius8,
      boxShadow: theme.shadows[4],
      border: `1px solid ${theme.toast.notification.border}`,
      overflow: 'hidden', // Ensure pseudo-element doesn't overflow

      // Create backdrop filter using pseudo-element to avoid backdropFilter flickering while animating
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backdropFilter: theme.backdropFilter.xlarge,
        WebkitBackdropFilter: theme.backdropFilter.xlarge,
        borderRadius: theme.shape.radius8,
        pointerEvents: 'none',
        zIndex: -1,
      },

      // Browser optimisations for smoother animations
      isolation: 'isolate',
      willChange: 'opacity',
    },
  };
};
